import api from "./Api";

class TicketService {
  GetTicket(payload) {
    return api.get("/v1/ticket/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTicket(payload) {
    return api.post("/v1/ticket/", payload).then((response) => {
      return response.data;
    });
  }

  PutTicket(payload) {
    return api.put("/v1/ticket/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTicket(payload) {
    return api.delete("/v1/ticket/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTicketOData(payload) {
    return api.get("/OData/Ticket" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TicketService();
